module.exports = __webpack_public_path__ + "img/ZIP-small.5a4743b.svg";